import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Row, Col, Input, notification, Modal } from "antd";
import { Link } from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import LoginPic from '../assets/images/finekralogo.png'
import LoginPicImza from '../assets/images/imzaPosLogo.png'
import LoginPicBakiyem from '../assets/images/logoBakiyem.png'
import Screen from '../util/Extensions/Screens'
import { useSelector } from "react-redux";
import RequestHandler from "../util/RequestHandler";

const SignIn = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [visible, setVisible] = useState(false);
  const [mailLogin, setMailLogin] = useState("");
  const [psr, setPsr] = useState("");
  const [smsPsrInput, setSmsPsrInput] = useState("");
  const { initialMinute = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(180);
  const [errorText, setErrorText] = useState("");

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          handleCancel()
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000)
    return () => {
      clearInterval(myInterval);
    };
  });

  const [form] = Form.useForm();

  const showModal = () => {
    setSeconds(180)
    setSmsPsrInput("")
    setErrorText("")
    setVisible(true)
  }

  const handleSubmit = (values) => {
    RequestHandler.post(`/Auth/Login`, {
      email: mailLogin,
      password: psr,
      screenOption: Screen.screen,
      securityKey: values.Sms
    }, false).then((response) => {
      if(response.success){
        setLoading(false);
        RequestHandler.setUserInfo(response);
        window.location.reload();
      }else{
        setLoading(false)
        setLoadingBtn(false)
      }
     
    });
  }

  const handleCancel = () => {
    if (handleCancel) {
      setLoading(false)
    }
    setVisible(false)
    setLoadingBtn(false)
  };

  const token = useSelector(({ auth }) => auth.token);
  const onFinishFailed = () => setLoading(false);

  const onFinish = values => {
    // axios.get(`${config.apiUrl}/Auth/PsrControl?email=${values.email}`).then(({data}) => {
    //     if(data === null || data === ""){
    RequestHandler.post(`/Auth/Login`, {
      email: values.email,
      password: values.password,
      screenOption: Screen.screen
    }, false).then((response) => {
      if (response.success) {
        if (response.data === null) {
          showModal()
          setMailLogin(values.email)
          setPsr(values.password)
        } else {
          RequestHandler.setUserInfo(response);
          openNotificationWithIcon("success");
          window.location.reload();
        }
      } else {
        setLoading(false);
      }
    });
    // }else{
    //   props.history.push(`/reset-password/${data}/true`);
    // }
    // }).catch(function (error) {
    //   if(error.response.status === 406){
    //     error.response.data.data.map((item)=>{
    //       errorList.push(item);
    //     })
    //     errorListNotification('error')
    //     setLoadingBtn(false)
    //     setLoading(false)
    //     }else{
    //         sameError('error')
    //         setLoading(false)
    //         setLoadingBtn(false)
    //     }
    //   });
  };

  const onChangePsrLoginValue = (e) => {
    setErrorText("")
    setSmsPsrInput(e.target.value)
  }

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Giriş işlemi başarılı.',
      duration: 2,
    });
  };

  const ref = useRef();
  useEffect(() => {
    if (token !== null) {
      props.history.push('/home');
    }
  }, [token, props.history]);

  return (
    <div className="gx-login-container">
      <div className="gx-login-content">
        <div className="gx-login-header gx-text-center">
          <h1 className="gx-login-title">
            {/* {Screen.screen === 0 ?
              <img src={LoginPic} alt='Paratic' style={{ marginBottom: '11%', width: '64%' }} />
              :
              (
                Screen.screen === 1 ?
                  <img src={LoginPicImza} alt='Imzapos' style={{ marginBottom: '11%', width: '64%' }} />
                  :
                  <img src={LoginPicBakiyem} alt='Bakiyem' style={{ marginBottom: '11%', width: '64%' }} />
              )
            } */}

          {Screen.screen === 0 ?
              <img src={LoginPic} alt='Paratic' style={{ marginBottom: '8%', width: '76%',marginRight:'3%' }} />
              :
              (
                Screen.screen === 1 ?
                  <img src={LoginPicImza} alt='Imzapos' style={{ marginBottom: '11%', width: '64%' }} />
                  :
                  <img src={LoginPicBakiyem} alt='Bakiyem' style={{ marginBottom: '11%', width: '64%' }} />
              )
            }

          </h1>
        </div>
        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">
          <Form.Item rules={[{ required: true, message: 'Email alanı zorunludur!' }]} name="email">

            <Input prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Email" autoComplete={false} />
          </Form.Item>
          <Form.Item rules={[{ required: true, message: 'Şifre alanı zorunludur!' }]} name="password">

            <Input prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Şifre" autoComplete={false}/>
          </Form.Item>
          <Link className="gx-login-form-forgot" to="/forget-password">Şifremi Unuttum</Link>
          <Form.Item className="gx-text-center">
            <Button type="primary" htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
              Giriş Yap
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Modal maskClosable={false} visible={visible} onOk={form.submit} okButtonProps={{ hidden: true }} keyboard={false} cancelButtonProps={{ hidden: true }} onCancel={handleCancel}>
        <p style={{ marginTop: 10, textAlign: 'center', fontSize: 16 }}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>

        <Form
          onFinish={handleSubmit}
          fields={[
            { name: "Sms", value: smsPsrInput },
          ]}
          ref={ref}
        >
          <Form.Item
            name="Sms"
          >
            <Input onChange={onChangePsrLoginValue} type='text' maxLength={6}
              autoComplete="off"
              style={{ marginTop: 40 }} onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
                if (event.key === "Enter") {
                  ref.current.submit();
                }
              }} />
          </Form.Item>
          <Row style={{ marginBottom: -25 }}>

            <Col span={15}></Col>
            <Col span={6}>
              <Form.Item  >
                <Button type="primary" htmlType="submit" onClick={() => setLoadingBtn(true)} loading={loadingBtn}>
                  Onayla
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}></Col>
          </Row>
        </Form>
        <p style={{ color: 'darkred', textAlign: 'center', fontWeight: 600 }}>{errorText}</p>
      </Modal>
    </div>
  );
};

export default SignIn;
